import {createLayer} from './design-model.js';
import {PHOTO_DECORATIONS} from './photo-catalog.js';
import {removeNailLayer} from './layer-stack.js';

export const decorationLayers=(nail,id)=>(nail.layers||[]).filter(layer=>layer.kind==='charm'&&layer.type===id&&layer.visible!==false&&layer.opacity!==0);

// Prefer open positions around the centre so repeated pieces are individually
// visible and selectable. Existing pieces, including their transforms, stay put.
function nextPosition(nail) {
 const occupied=nail.layers.filter(layer=>['charm','sticker'].includes(layer.kind)&&layer.visible!==false&&layer.opacity!==0);
 const candidates=[];
 for(const y of [75,53,97,31,119])for(const x of [50,28,72])candidates.push({x,y});
 const distance=point=>occupied.length?Math.min(...occupied.map(layer=>Math.hypot(point.x-layer.x,point.y-layer.y))):Infinity;
 return candidates.find(point=>distance(point)>=20)||candidates.reduce((best,point)=>distance(point)>distance(best)?point:best);
}

// +/- changes exactly one visible piece per targeted nail, atomically. Hidden
// pieces don't count in the quote and are never silently removed by minus.
export function changeDecorationQuantity(design,indices,id,delta,{selectedId}={}) {
 const item=PHOTO_DECORATIONS.find(decoration=>decoration.id===id);
 const targets=[...new Set(indices)].filter(index=>Number.isInteger(index)&&index>=0&&index<design.nails.length);
 if(!item||!targets.length||![1,-1].includes(delta))return design;
 if(delta===1&&targets.some(index=>design.nails[index].layers.length>=80))throw new Error('甲片图层已满，请先整理图层');
 if(delta===-1&&!targets.some(index=>decorationLayers(design.nails[index],id).length))return design;
 const next=structuredClone(design);
 for(const index of targets){
  const nail=next.nails[index];
  if(delta===1)nail.layers.push(createLayer('charm',{type:id,sizeMm:item.defaultSize||3,color:item.color||'#d4b170',clip:false,...nextPosition(nail)}));
  else {
   const matches=decorationLayers(nail,id),removed=matches.find(layer=>layer.id===selectedId)||matches.at(-1);
   if(removed)next.nails[index]=removeNailLayer(nail,removed.id);
  }
 }
 return next;
}
